export default "__VITE_ASSET__D1KSJy64__"